import { UpgradeSubscriptionButton } from '@modules/Dashboard/modules/Subscriptions';
import React from 'react';
import * as S from './UpgradeSubscriptionBanner.styled';
export const UpgradeSubscriptionBanner = ({ children, onUpgradeClick, }) => {
    return (React.createElement(S.Container, null,
        React.createElement("div", null, children),
        React.createElement(UpgradeSubscriptionButton, { onClick: onUpgradeClick })));
};
